import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { useMemo } from 'react'
import LuxPlusHiddenOfferDetails from './LuxPlusHiddenOfferDetails'
import LuxPlusHiddenOfferImageContainer from './LuxPlusHiddenOfferImageContainer'
import Image from 'components/Common/Image/Image'
import useHiddenOfferClickHandler from './useHiddenOfferClickHandler'
import NestableClickable from 'components/Common/NestableClickable'
import { LabelCountProvider } from 'contexts/LabelCountContext'
import getResizableImage from 'components/OfferList/OfferCards/getResizableImage'

const LayoutWrapper = styled(NestableClickable)`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  height: 100%;
  position: relative;

  &.hidden {
    visibility: hidden;
    display: none;
  }
`

interface Props {
  offer: App.Offer | App.OfferSummary
  className?: string
  urgencyLabels?: Array<App.OfferUrgencyLabel>
  size?: 'small' | 'medium'
}

function LuxPlusHiddenOfferCarouselCard(props: Props) {
  const {
    offer,
    urgencyLabels,
    className,
    size = 'medium',
  } = props
  const onHandleHiddenOffer = useHiddenOfferClickHandler(offer)
  const intl = useIntl()
  const image = useMemo(() => getResizableImage(offer.image), [offer.image])
  const imageWidth = size === 'small' ? 320 : 512

  return <LabelCountProvider maxLabels={2}>
    <LayoutWrapper className={`lux-plus-hidden-offer-card ${className || ''}`} onClick={onHandleHiddenOffer}>
      <LuxPlusHiddenOfferImageContainer size={size}>
        <Image
          aspectRatio="3:2"
          image={image}
          fit="center"
          quality="low"
          width={imageWidth}
          alt={intl.formatMessage(
            {
              id: 'kCTgub4earGNxPXIxs0E',
              defaultMessage: 'Exclusive hidden offer in {location}',
            },
            { location: offer.locationSubheading },
          )}
        />
      </LuxPlusHiddenOfferImageContainer>
      <LuxPlusHiddenOfferDetails offer={offer} urgencyLabels={urgencyLabels} />
    </LayoutWrapper>
  </LabelCountProvider>
}

export default LuxPlusHiddenOfferCarouselCard
